import React from 'react';
interface ButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  variant?: 'primary' | 'secondary';
}
export function Button({
  children,
  onClick,
  className = '',
  variant = 'primary'
}: ButtonProps) {
  const baseStyles = 'px-8 py-4 rounded-lg font-medium text-lg transition-all duration-300 focus:outline-none focus:ring-4 focus:ring-offset-2';
  const variantStyles = {
    primary: 'bg-[#C17B6B] text-white hover:bg-[#B06A5A] focus:ring-[#C17B6B]/30 shadow-lg hover:shadow-xl hover:-translate-y-0.5',
    secondary: 'bg-[#7B9FAB] text-white hover:bg-[#6A8E9A] focus:ring-[#7B9FAB]/30'
  };
  return <button onClick={onClick} className={`${baseStyles} ${variantStyles[variant]} ${className}`} aria-label={typeof children === 'string' ? children : undefined} data-id="element-1">
      {children}
    </button>;
}